import React from "react";

const renderImage = (peopleImagesUrl) =>{
  if(peopleImagesUrl!==undefined) {
    return <img className="mb-3" src={peopleImagesUrl} />
  }
  return null;
} 

const renderEmail = (peopleEmailId) => {
  if(peopleEmailId !== undefined) {
    return <a href={`mailto:${peopleEmailId}`} target="_blank">
    {peopleEmailId}
    <br />
  </a>
  }
  return null;
}

const renderLinkedIn = (peopleLinkedIn) => {
  if(peopleLinkedIn !== undefined) {
    return <a href={`${peopleLinkedIn}`} target="_blank">LinkedIn</a>
  }
  return null;
}

const renderDescription = (peopleDescription) => {
  if(peopleDescription !== undefined){
    return <pre>{peopleDescription}</pre>
  }
  return null;
}

const PeopleCard = (props) => {
  return (
    <div className="col-lg-4">
      <div className="card remove-border d-flex align-items-center mb-4">
        {renderImage(props.peopleImagesUrl)}
        <div className="card-body text-center">
          <b className="PeopleName">
            <a className="remove-underline color-black" target="_blank" href={`${props.link}`}>
              {props.peopleName}
            </a>
          </b>
          {renderEmail(props.peopleEmailId)}
          {renderDescription(props.peopleDescription)}
          {renderLinkedIn(props.peopleLinkedIn)}
        </div>
      </div>
    </div>
  );
};

export default PeopleCard;
